<template>
  <section class="container-onboarding-content">
    <div class="wrapper-title">
      <h3>
        <AnimatedGradientText>{{ t('onboarding_hello') }}</AnimatedGradientText>
      </h3>
      <h4 class="medium">
        <AnimationTyping :text="t('onboarding_natural_interpretation_scon')" />
      </h4>
    </div>
<!--
    <h4 class="regular fadeinOnboarding late">
      {{ t('onboarding_more_questions') }}
    </h4>
    
    <div class="wrapper-video fadeinOnboarding">
      <video autoplay loop muted class="status-video">
        <source src="/videos/scon-linear.mp4" type="video/mp4" />
      </video>
      <div class="side left" />
      <div class="side right" />
    </div>
-->
  </section>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

import AnimationTyping from '@/components/animations/AnimationTyping.vue';
import AnimatedGradientText from '@/components/shared/base/AnimatedGradientText.vue';

const { t } = useI18n();
</script>

<style scoped>
.wrapper-video {
  position: relative;
  display: flex;
  width: 100%;
  max-width: 25rem;
  max-height: 10rem;
  justify-content: center;
  align-items: center;
  margin-bottom: 2rem;
  overflow: hidden;

  &::before,
  &::after,
  .side {
    content: '';
    position: absolute;
    pointer-events: none;
    z-index: 2;
  }

  /* 위 */
  &::before {
    top: 0;
    left: 0;
    width: 100%;
    height: 5rem;
    background: linear-gradient(to bottom, #fff, transparent);
  }

  /* 아래 */
  &::after {
    bottom: 0;
    left: 0;
    width: 100%;
    height: 5rem;
    background: linear-gradient(to top, #fff, transparent);
  }

  /* 좌 */
  .side.left {
    top: 0;
    left: 0;
    width: 3rem;
    height: 100%;
    background: linear-gradient(to right, #fff, transparent);
  }

  /* 우 */
  .side.right {
    top: 0;
    right: 0;
    width: 3rem;
    height: 100%;
    background: linear-gradient(to left, #fff, transparent);
  }

  .status-video {
    display: block;
    flex: 0 0 auto;
    width: 100%;
    min-width: 100%;
    height: auto;
    transition:
      transform 240ms ease,
      filter 240ms ease,
      opacity 240ms ease,
      outline-color 240ms ease;
  }
}
</style>
